import styled from "styled-components";

export const PageContainer = styled.div.attrs({
  className: "bg-gray-100 py-12 px-4",
})``;

export const ImageTextContainer = styled.div.attrs({
  className: "relative text-center bg-gray-100 py-12 px-6",
})``;

export const BannerImage = styled.img.attrs({
  className: "w-full h-[300px] object-cover rounded-lg shadow-md",
})``;

export const TextBelowImage = styled.div.attrs({
  className: "mt-6",
})``;

export const TextTitle = styled.p.attrs({
  className: "text-5xl text-gray-700",
})``;

export const ImageSections = styled.div.attrs({
  className:
    "flex flex-col md:flex-row justify-center items-center space-y-6 md:space-y-0 md:space-x-16",
})``;

export const ImageBox = styled.div.attrs({
  className: "text-center",
})``;

export const ImageBoxImg = styled.img.attrs({
  className: "w-96 h-96 rounded-full object-cover mx-auto",
})``;

export const ImageBoxButton = styled.button.attrs({
  className: "mt-4 px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-800",
})``;

export const SubscribeSection = styled.div.attrs({
  className: "mt-12 text-center",
})``;

export const SubscribeHeading = styled.h2.attrs({
  className: "text-2xl font-semibold text-gray-800",
})``;

export const SubscribeDescription = styled.p.attrs({
  className: "text-gray-600 mt-2",
})``;

export const SubscribeForm = styled.div.attrs({
  className: "mt-6 flex justify-center items-center space-x-4",
})``;

export const SubscribeInput = styled.input.attrs({
  className:
    "px-4 py-2 w-80 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-600",
})``;

export const SubscribeButton = styled.button.attrs({
  className: "px-6 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-800",
})``;

export const SuccessMessage = styled.div.attrs({
  className: "mt-4 text-green-600",
})``;
